import React from "react";
import { useDispatch } from "react-redux";
import { Modal } from "semantic-ui-react";
import { closeModal, clearAdData } from "../actions";
import AdData from "../banner/ad-data";

const AdDataModal = props => {
  const dispatch = useDispatch();

  const clear = () => {
    dispatch(clearAdData());
    dispatch(closeModal());
  };

  return (
    <Modal closeIcon="close" open={true} onClose={() => clear()} {...props}>
      <Modal.Content>
        <AdData />
      </Modal.Content>
    </Modal>
  );
};

export default AdDataModal;
